export const COURSE_FORM_FIELD_LABELS = {
    headerImage: 'Imagen de portada',
    identifier: 'Identificador del curso',
    duration: 'Duración del curso',
    schedule: 'Días de clase y horario',
    level: 'Nivel',
    language: 'Idioma',
    color: 'Etiqueta de color',
    limitMembers: 'Límite de estudiantes',
    teacher: 'Profesor',
    moderator: 'Moderador del grupo',
};

const hasEntityId = (value) => Boolean(
    value && (typeof value === 'string' ? value.trim() : value._id),
);

const createEmptyCourseFormErrors = () => ({
    headerImage: '',
    identifier: '',
    duration: '',
    schedule: '',
    level: '',
    language: '',
    color: '',
    limitMembers: '',
    teacher: '',
    moderator: '',
});

export { createEmptyCourseFormErrors };

/**
 * @param {object} courseSelected
 * @param {{ _id?: string } | null} headerImageSelected
 * @returns {{ isValid: boolean, errors: ReturnType<typeof createEmptyCourseFormErrors> }}
 */
export const validateCourseFormValues = (courseSelected, headerImageSelected) => {
    const errors = createEmptyCourseFormErrors();

    if (!headerImageSelected?._id && !courseSelected?.headerImage) {
        errors.headerImage = 'Selecciona una imagen de portada para el curso.';
    }

    if (!courseSelected?.identifier?.trim()) {
        errors.identifier = 'Ingresa un identificador para el curso.';
    }

    if (!courseSelected?.fromDate || !courseSelected?.toDate) {
        errors.duration = 'Selecciona la fecha de inicio y fin del curso.';
    } else if (new Date(courseSelected.fromDate) > new Date(courseSelected.toDate)) {
        errors.duration = 'La fecha de inicio no puede ser posterior a la fecha de fin.';
    }

    const hasDays = Array.isArray(courseSelected?.days) && courseSelected.days.length > 0;
    const hasHours = Array.isArray(courseSelected?.hours) && courseSelected.hours.length > 0;
    if (!hasDays || !hasHours) {
        errors.schedule = 'Selecciona al menos un día y las horas de inicio y fin.';
    }

    if (!hasEntityId(courseSelected?.level)) {
        errors.level = 'Selecciona el nivel del curso.';
    }

    if (!hasEntityId(courseSelected?.language)) {
        errors.language = 'Selecciona el idioma del curso.';
    }

    if (!hasEntityId(courseSelected?.color)) {
        errors.color = 'Selecciona una etiqueta de color.';
    }

    const limitMembers = Number(courseSelected?.limitMembers);
    if (!Number.isFinite(limitMembers) || limitMembers <= 0) {
        errors.limitMembers = 'Indica un límite de alumnos mayor a 0.';
    }

    if (!hasEntityId(courseSelected?.teacher)) {
        errors.teacher = 'Selecciona un profesor para el curso.';
    }

    if (!hasEntityId(courseSelected?.moderator)) {
        errors.moderator = 'Selecciona un moderador para el grupo.';
    }

    const isValid = !Object.values(errors).some(Boolean);

    return { isValid, errors };
};

const quoteFieldLabel = (label) => `«${label}»`;

/**
 * Mensaje corto para toast cuando falla la validación del formulario de curso.
 * @param {string[]} missingLabels
 */
export const buildCourseValidationToastMessage = (missingLabels) => {
    const count = missingLabels.length;

    if (count === 0) return '';
    if (count === 1) {
        return `Completa ${quoteFieldLabel(missingLabels[0])} para guardar el curso.`;
    }
    if (count === 2) {
        return `Completa ${quoteFieldLabel(missingLabels[0])} y ${quoteFieldLabel(missingLabels[1])} para guardar el curso.`;
    }

    return `Faltan ${count} campos obligatorios. Revisa el aviso al inicio del formulario.`;
};
